// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip__OvEQe","fadeIn":"fadeIn__E2+dp","icon":"icon__yONm2","left":"left__aHO1k","right":"right__4OkWu","warning":"warning__L8tqD"};